/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  var swiperInstance = null;

  function initSocialProofSwiper() {
    var swiperEl = document.querySelector('.social-proof__slider');
    if (!swiperEl) return;
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
    swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      grabCursor: true,
      speed: 300,
      resistanceRatio: 0.85,
      touchRatio: 1,
      touchAngle: 45,
      threshold: 3,
      followFinger: true,
      watchSlidesProgress: true,
      navigation: {
        prevEl: '.social-proof__nav-btn--prev',
        nextEl: '.social-proof__nav-btn--next',
      },
      pagination: {
        el: '.social-proof__dots',
        clickable: true,
      },
      breakpoints: {
        799: { enabled: false,
          spaceBetween: 0
         },
      },
    });

    requestAnimationFrame(function () {
      if (swiperInstance) swiperInstance.update();
    });
  }

  window.initSocialProofSwiper = initSocialProofSwiper;

  function deskSocialProofRevealOnScroll() {
    var $elements = $('.social-proof .sr-hidden');
    if (!$elements.length) return;

    function showInstantly($els) {
      $els.each(function () {
        if (typeof ScrollReveal !== 'undefined') ScrollReveal().clean(this);
        $(this).css({ visibility: 'visible', opacity: 1, transform: 'none' });
      });
    }

    if (window.innerWidth > 799 && typeof ScrollReveal !== 'undefined') {
      $elements.each(function (i, el) {
        ScrollReveal().reveal(el, {
          origin: 'bottom',
          distance: '20px',
          duration: 700,
          delay: 40 + i * 40,
          easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
          opacity: 0,
          scale: 1,
          once: true,
        });
      });
    } else {
      showInstantly($elements);
    }
  }

  deskSocialProofRevealOnScroll();
  initSocialProofSwiper();
});